import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import PaymentTrust from "../components/PaymentTrust";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); clear(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { setStatus("error"); return; }
      if (tries++ < 8) setTimeout(poll, 2000); else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="pt-40 pb-32 min-h-[70vh] flex flex-col items-center text-center px-6">
      {status === "checking" && <><Loader2 size={48} className="animate-spin mb-6" stroke="var(--lo-rose)" /><h1 className="font-display text-4xl" style={{ fontWeight: 300 }}>Confirmation du paiement...</h1></>}
      {status === "paid" && <><CheckCircle2 size={56} className="mb-6" stroke="var(--lo-rose)" /><h1 className="font-display text-5xl mb-4" style={{ fontWeight: 300 }} data-testid="payment-success">Merci pour votre commande</h1><p className="text-sm mb-10" style={{ color: "var(--lo-muted)" }}>Votre paiement a bien été confirmé. Vous recevrez un email de suivi.</p><PaymentTrust compact /><Link to="/" className="btn-primary inline-flex items-center h-14 px-10">Retour à l'accueil</Link></>}
      {(status === "error" || status === "timeout") && <><XCircle size={56} className="mb-6" stroke="#e08" /><h1 className="font-display text-4xl mb-4" style={{ fontWeight: 300 }}>Un souci est survenu</h1><p className="text-sm mb-10" style={{ color: "var(--lo-muted)" }}>Le statut du paiement n'a pas pu être confirmé. Contactez-nous si le montant a été débité.</p><PaymentTrust compact /><Link to="/panier" className="btn-ghost inline-flex items-center h-14 px-10">Retour au panier</Link></>}
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="pt-40 pb-32 min-h-[70vh] flex flex-col items-center text-center px-6">
      <XCircle size={56} className="mb-6" stroke="var(--lo-muted)" />
      <h1 className="font-display text-5xl mb-4" style={{ fontWeight: 300 }} data-testid="payment-cancel">Paiement annulé</h1>
      <p className="text-sm mb-10" style={{ color: "var(--lo-muted)" }}>Votre commande n'a pas été finalisée. Votre panier est conservé.</p>
      <Link to="/panier" className="btn-primary inline-flex items-center h-14 px-10">Reprendre ma commande</Link>
    </div>
  );
}
